import { Cpu } from "lucide-react";

const METHOD_STYLES = {
  obd: "bg-[#2D6A4F]/30 text-[#6AB04C] border border-[#2D6A4F]/50",
  bench: "bg-[#FF8C00]/15 text-[#FF8C00] border border-[#FF8C00]/30",
};

const MethodBadge = ({ method }) => (
  <span className={`px-2 py-0.5 rounded text-[10px] uppercase tracking-wider font-semibold ${METHOD_STYLES[method] || "bg-[#FF3B30]/15 text-[#FF3B30] border border-[#FF3B30]/30"}`}>
    {method}
  </span>
);

export default function EcuSection({ ecus }) {
  if (!ecus || ecus.length === 0) return null;

  const hasBenchBoot = ecus.some((ecu) =>
    ecu.methods?.some((m) => m === "bench" || m === "boot")
  );

  return (
    <>
      <div data-testid="ecu-methods-section" className="mt-6">
        <div className="flex items-center gap-2 mb-3">
          <Cpu size={16} className="text-[#FF3B30]" />
          <span className="text-xs text-[#8A8A8A] uppercase tracking-wider">ECU Types & Tuning Methods</span>
        </div>
        <div className="grid gap-2">
          {ecus.map((ecu, i) => (
            <div key={`${ecu.ecu_manufacturer}-${ecu.ecu}-${i}`} className="flex flex-col sm:flex-row sm:items-center justify-between bg-[#0A0A0A] rounded-lg px-4 py-3 border border-[#2A2A2A]">
              <div className="flex items-center gap-2 mb-2 sm:mb-0">
                <span className="text-white text-sm font-medium">{ecu.ecu_manufacturer} {ecu.ecu}</span>
                {ecu.mcu && <span className="text-[#6A6A6A] text-xs">{ecu.mcu}</span>}
              </div>
              <div className="flex items-center gap-2">
                {ecu.methods.map((method) => <MethodBadge key={method} method={method} />)}
              </div>
            </div>
          ))}
        </div>
      </div>

      {hasBenchBoot && (
        <div data-testid="ecu-dropoff-notice" className="mt-6 bg-[#FF8C00]/10 border border-[#FF8C00]/30 rounded-lg p-4">
          <p className="text-[#FF8C00] text-sm font-semibold mb-1">ECU Drop-off Required</p>
          <p className="text-[#B0B0B0] text-xs leading-relaxed">
            This ECU requires bench or boot mode for tuning. Please drop off your ECU at our location after making an appointment.
          </p>
        </div>
      )}
    </>
  );
}
